var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#EAF2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10H10.5C9.25736 10 8.25 11.0074 8.25 12.25V19.75C8.25 20.9926 9.25736 22 10.5 22H19.5C20.7426 22 21.75 20.9926 21.75 19.75V12.25C21.75 11.0074 20.7426 10 19.5 10Z",
    stroke: "#2C71DD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 16C13.5784 16 14.25 15.3284 14.25 14.5C14.25 13.6716 13.5784 13 12.75 13C11.9216 13 11.25 13.6716 11.25 14.5C11.25 15.3284 11.9216 16 12.75 16Z",
    stroke: "#2C71DD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 13H18.75",
    stroke: "#2C71DD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 16H18.75",
    stroke: "#2C71DD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 19H18.75",
    stroke: "#2C71DD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactCardIcon);
export default __webpack_public_path__ + "static/media/contact_card_icon.e0b3eaf2a12c6f89a3551db882faf878.svg";
export { ForwardRef as ReactComponent };